import { useIsTokenListed } from '@trustpad/launchpad';

import React from 'react';

import { SecondaryCard, StandardCard } from '~common/UI';
import { usePool } from '~features/pools';
import { SaleState } from '~features/pools/components/SaleState';
import { StandardFinishedInfo } from '~features/pools/components/StandardFinishedInfo';
import { TokenInfo } from '~features/pools/components/TokenInfo';

import { NftPoolConfig, SaleStatus } from '../types';
import { BuyFormWrapper } from './BuyFromWrapper';

export function PoolPrimaryBlock() {
  const {
    pool,
    pool: { sale },
  } = usePool<NftPoolConfig>();
  const { isListed } = useIsTokenListed();

  const showFinishedInfo = sale.status === SaleStatus.finished && isListed;

  return (
    <StandardCard
      cardClassName="bg-dark1 bg-opacity-90 rounded-lg shadow-2xl"
      className="space-y-6 p-3">
      <TokenInfo />

      {showFinishedInfo && (
        <SecondaryCard>
          <StandardFinishedInfo pool={pool} />
        </SecondaryCard>
      )}

      <BuyFormWrapper />

      <SaleState />
    </StandardCard>
  );
}
